import PaymentHistory from 'features/believe/PaymentHistory/PaymentHistory';
import React from 'react';

export default function PaymentHistoryPage() {
  return <PaymentHistory />;
}
